import React from 'react';
import './CategorySelector.css'

export class CategorySelector extends React.Component {
    render() {
        return(
            <div>
                <div className = "category-selector">
                    <a> Burgers </a>
                    <a href="#Salads"> Salads </a>
                    <a href="#Wraps"> Wraps  </a>
                    <a href="#Subs"> Subs </a>
                    <a href="#Sandwiches"> Sandwiches </a>
                </div>
                <select as="select" className = "mobile-category-selector">
                    <option value = "Burgers"><a> Burgers </a></option>
                    <option value = "Salads"><a href="#Salads"> Salads </a></option>
                    <option value = "Wraps"><a href="#Wraps"> Wraps  </a></option>
                    <option value = "Subs"><a href="#Subs"> Subs </a></option>
                    <option value = "Sandwiches"><a href="#Sandwiches"> Sandwiches </a></option>
                </select>
            </div>
        );
    }

}